import { axiosWithRails } from "./axiosWithRails";

export type ProjectType = {
  title: string | null;
  language: string;
  uid: string;
  id: string;
  created_at: string;
  share: string;
  favorite: string;
  featured: string;
  source_files: { body: string }[] | null;
  user: {
    id: string;
    username: string;
    image_url: string | null;
  } | null;
};

export type ProjectsType = {
  count: number;
  projects: ProjectType[];
};

export type GetProjectsParams = {
  language?: string;
  only_me?: boolean;
  only_featured?: boolean;
  only_favorite?: boolean;
  limit?: number;
  offset?: number;
  search_text?: string;
  user_id?: string;
};

const cleanSearchParams = (obj: object) => {
  return Object.keys(obj).reduce(
    (result, key) =>
      obj[key] === null || obj[key] === undefined
        ? result
        : Object.assign(result, { [key]: obj[key].toString() }),
    {},
  );
};

export const getProjects = async (params: GetProjectsParams) => {
  const query = new URLSearchParams(cleanSearchParams(params));
  const url = `/api/projects.json${query ? `?${query}` : ""}`;
  return axiosWithRails.get(url).then((result) => {
    return result.data as ProjectsType;
  });
};
